import { Step as NovaStep, StepLabel as NovaStepLabel, Stepper as NovaStepper } from '@fme-nova/components'
import { Step as MuiStep, StepLabel as MuiStepLabel, Stepper as MuiStepper } from '@mui/material'

import { createComponentWrapperWithRef } from '../../theme'

export const Stepper = createComponentWrapperWithRef(
  {
    mui: MuiStepper,
    nova: NovaStepper,
  },
  'Stepper',
)

export const Step = createComponentWrapperWithRef(
  {
    mui: MuiStep,
    nova: NovaStep,
  },
  'Step',
)

export const StepLabel = createComponentWrapperWithRef(
  {
    mui: MuiStepLabel,
    nova: NovaStepLabel,
  },
  'StepLabel',
)
